<div class="box relative">
    <app-loader *ngIf="appending$ | async" loaderColor="default" loaderType="cover" overlayColor="white"></app-loader>
    <div #ps class="h-100 relative inner" [perfectScrollbar]="{ suppressScrollX: true, wheelPropagation: false }" (psYReachEnd)="psYReachEnd()">
        <div [ngClass]="{ 'pe-4': scrollbarYEnabled }">
            <div *ngFor="let user of users$ | async; let last = last" [ngClass]="{ 'mb-1': !last }" [elementDataTest]="user.id">
                <app-byoc-episode-step-users-list-user [user]="user"></app-byoc-episode-step-users-list-user>
            </div>
        </div>
    </div>
</div>
